import { $fetch } from '@/boot/fetch'

function endpoint(retailerId) {
  return `/retailers/${retailerId}/agents/onboarding`
}

export default {
  startConversation(retailerId) {
    return $fetch.peg(`${endpoint(retailerId)}/start`, { method: 'POST' })
  },
  sendMessage(retailerId, conversationIdOrBody, message) {
    const body =
      typeof conversationIdOrBody === 'object' ? { ...conversationIdOrBody } : { conversationId: conversationIdOrBody, message }

    return $fetch.peg(`${endpoint(retailerId)}/message`, {
      method: 'POST',
      body,
    })
  },
  uploadFiles(retailerId, { conversationId, purpose, files }) {
    const formData = new FormData()
    formData.append('conversationId', conversationId)
    formData.append('purpose', purpose)

    for (const file of files || []) {
      formData.append('files', file)
    }

    return $fetch.peg(`${endpoint(retailerId)}/files`, {
      method: 'POST',
      body: formData,
    })
  },
  getStatus(retailerId) {
    return $fetch.peg(`${endpoint(retailerId)}/status`)
  },
  getHistory(retailerId, conversationId) {
    return $fetch.peg(`${endpoint(retailerId)}/history`, {
      params: { conversationId },
    })
  },
  skipStep(retailerId, { step, reason }) {
    return $fetch.peg(`${endpoint(retailerId)}/skip`, {
      method: 'POST',
      body: { step, ...(reason ? { reason } : {}) },
    })
  },
  resumeStep(retailerId, { step }) {
    return $fetch.peg(`${endpoint(retailerId)}/resume`, {
      method: 'POST',
      body: { step },
    })
  },
}
